export default {
  'meta': {
    'langName': 'TURKISH',
    'lang': 'Türkçe'
  },
  'title': 'ÜRÜN GERİ ÇAĞIRMA: BASKETBOL POTASI B900 BOX NBA TARMAK',
  'description': 'Basketbol potamız B900\'ün direğinin, yükseklik ayar kolu takılı olmadan kullanılması veya üzerinde işlem yapılması durumunda düşme riski taşıdığını tespit ettik.\nGüvenliğiniz için, yükseklik ayar kolu takılı değilken ürünü kullanmayı derhal bırakmanızı rica ediyoruz.\nÜrününüzü basit bir işlemle sabitlemeniz mümkün olacak. Size ücretsiz olarak bir onarım kiti göndereceğiz.\nBu geri çağırma işlemi için özel olarak hazırlanan web sitemiz şu anda yapım aşamasındadır. Web sitemiz, bu işlemi nasıl gerçekleştireceğiniz konusunda size adım adım rehberlik edecektir.\nWeb sitemiz kullanıma açılır açılmaz (Temmuz ayı içinde) sizi bilgilendireceğiz.',
  'status': 'Translation validated by COUNTRY'
} as const
